import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Thumbnail from '../thumbnail';

function Projects({ url }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadData = async () => {
      const result = await axios.get(url);
      if (mounted) {
        setData(result.data);
      }
    };
    loadData();

    return () => {
      mounted = false;
    };
  }, [url]);

  return (
    <div className="page">
      {!data ? (
        <div data-testid="loading">Loading data...</div>
      ) : (
        <div data-testid="resolved">
          {Array.isArray(data) && data.length > 0 ? (
            data.map(project => (
              <Thumbnail
                key={project.client}
                client={project.client}
                friendlyName={project.name}
                image={project.thumb}
              />
            ))
          ) : (
            <div>JSON is not an array or the array is empty</div>
          )}
        </div>
      )}
    </div>
  );
}

export default Projects;
